import Spinner from 'react-bootstrap/Spinner'
import { LoaderProps } from './model'

const Loader = (spinnerProps: LoaderProps) => (
  <Spinner animation="border" {...spinnerProps} />
)

export default Loader
